




















































import { Component, Vue, Prop } from 'vue-property-decorator';

import isMobile from '@/utils/mobile-check';

import ReferralBoth from '@/components/icons/ReferralBoth.vue';
import ReferralExisting from '@/components/icons/ReferralExisting.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';
import { Typography } from '@/components/atoms';
import { FilledButton, Radio } from '@/components/molecules';
import {
  EBusinessReferralType,
  TBusinessReferralType
} from '@/models/marketingCenter/referral';

@Component({
  components: {
    Typography,
    FilledButton,
    Radio,
    ReferralBoth,
    ReferralExisting,
    ReferralNew
  }
})
export default class ChangeTypeReferral extends Vue {
  @Prop(String) value!: TBusinessReferralType;

  EBusinessReferralType = EBusinessReferralType;

  get isMobileDevice() {
    return isMobile();
  }

  get tPrefix() {
    return `referralProgram.creation.step-1`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }
}
